var app = angular.module("leonardo");

var UnitTurnStates = function ($stateProvider) {
  $stateProvider.state('unit-turn', {
    url: '/unit-turn',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'unit-turn.tasks',
    ncyBreadcrumb: {
      label: '{{ filterService.getLabelProperty() }}'
    }
  });

  $stateProvider.state('unit-turn.tasks', {
    url: "/tasks",
    taskMode: 'by_unit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit-turn/tasks.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'UnitTaskFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/unit-tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks'
    }
  });

  $stateProvider.state('unit-turn.make-ready', {
    url: "/workflow/make-ready",
    title: 'Make Ready Board',
    cssClass: 'page-make-ready-board',
    by_unit: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/make-ready/filters-base.html',
        controller: 'MakeReadyFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/make-ready/make-ready.html',
        controller: 'MakeReady'
      }
    },
    params: {
      range: [],
      page: 1,
      trigger: false,
    },
    ncyBreadcrumb: {
      label: 'Make Ready Board'
    }
  });

  $stateProvider.state('unit-turn.make-ready.table', {
    url: "/table",
    title: 'Make Ready Board',
    cssClass: 'page-make-ready-board',
    by_unit: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/make-ready/filters-base.html',
        controller: 'MakeReadyTableFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/make-ready/make-ready.html',
        controller: 'MakeReady'
      }
    },
    params: {
      range: [],
      page: 1,
      trigger: false,
    },
    ncyBreadcrumb: {
      label: 'Table'
    }
  });

  $stateProvider.state('unit-turn.past-due', {
    url: "/past-due",
    taskMode: 'by_unit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit-turn/past-due.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'UnitTaskFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/unit-tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Past Due'
    }
  });

  $stateProvider.state('unit-turn.workflows', {
    url: "/workflows",
    title: 'Unit Workflows',
    by_unit: true,
    only_filter_account: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/list.html',
        controller: 'WorkFlowList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Workflows'
    }
  });

  $stateProvider.state('unit-turn.workflows-launch', {
    url: "/workflows-launch",
    title: 'Launch Unit Workflow',
    by_unit: true,
    only_filter_account: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/launch.html',
        controller: 'WorkFlowLaunch'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Launch Unit Workflow'
    }
  });

  $stateProvider.state('unit-turn.workflows-instances', {
    url: "/workflows-instances",
    title: 'My Unit Workflows',
    by_unit: true,
    workflows_in_progress: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/instances-list.html',
        controller: 'WorkFlowInstanceList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowInstanceListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'My Unit Workflows'
    }
  });

  $stateProvider.state('unit-turn.workflows.add', {
    url: "/add",
    title: 'Add Unit Workflow',
    action: 'create',
    by_unit: true,
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/form.html',
        controller: 'WorkFlowForm'
      }
    },
    resolve: {
      workflowOjb: ['WorkFlowService', function (WorkFlowService) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Unit Workflow'
    }
  });

  $stateProvider.state('unit-turn.workflow-edit', {
    url: "/workflow/:pk/edit",
    title: 'Edit Unit Workflow',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    by_unit: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/form.html',
        controller: 'WorkFlowForm'
      }
    },
    resolve: {
      workflowOjb: ['WorkFlowService', '$stateParams', function (WorkFlowService, $stateParams) {
        return WorkFlowService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit Unit Workflow'
    }
  });
};

app.config(['$stateProvider', UnitTurnStates]);
